import { baseApi } from './baseApi';

// The Packages management page was removed — this API surface is trimmed down to the
// per-patient session summary, which the Sessions page, appointment popover and
// payment-collection modal still rely on. Package rows themselves are created/updated
// server-side as a side effect of billing.
export const sessionPackagesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    patientSessionSummary: build.query({
      query: (patientId) => `/session-packages/patient/${patientId}/summary`,
      transformResponse: (r) => r.data,
      providesTags: (_r, _e, patientId) => [
        { type: 'SessionPackage', id: patientId },
        { type: 'Session', id: 'LIST' },
        { type: 'Appointment', id: 'LIST' },
      ],
    }),
  }),
});

export const {
  usePatientSessionSummaryQuery,
} = sessionPackagesApi;
